import { createResource } from "~/lib/resourceFactory";
import { getHasPassword } from "./password.api";

type HasPasswordData = Awaited<ReturnType<typeof getHasPassword>>;

/** Whether the signed-in user has an email/password credential account. */
export const passwordStatusResource = createResource<
  HasPasswordData,
  undefined
>({
  key: (_) => ["password", "status"] as const,
  fetcher: (_) => getHasPassword(),
});
